/*
 * View for inspecting and changing attributes
 */

define(["marionette", "./template/attributesTemplate.html"], function (
  Marionette,
  AttibutesTemplate,
) {
  var AttributesView = {};

  AttributesView.attributesView = Marionette.Layout.extend({
    template: AttibutesTemplate,
    triggers: {
      "click #addAttribute": "add:attribute",
    },
    regions: {
      list: "#attributeList",
    },
  });

  return AttributesView;
});
